import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { SupportSheet } from "../../components/SupportSheet";
import { DEFERRED_ORIGINATION_ROUTES } from "../../constants";
import { HomePage } from "./HomePage";

export const SupportPage = memo(() => {
  const navigate = useNavigate();

  return (
    <>
      <HomePage />
      <SupportSheet
        namespace="deferred-origination"
        visible
        onClose={() => navigate(DEFERRED_ORIGINATION_ROUTES.HOME)}
      />
    </>
  );
});
